import {
  Flame, Snowflake, Wind, Factory, Cog, Waves, Gauge, Cpu, Lightbulb, Sun,
  HomeIcon, Thermometer, Droplets, Layers,
} from "lucide-react";

/**
 * 14 expertises techniques ECONATION.
 * Chaque item a un slug pour l'ancre et la liste des opérations
 * d'optimisation concrètes financées CEE.
 */
export const expertises = [
  {
    slug: "recuperation-chaleur",
    icon: Flame,
    label: "Récupération de chaleur",
    tagline: "Transformez vos rejets thermiques en actif énergétique.",
    fiche: "IND-UT-117 · IND-UT-134",
    valorisation: "50 000 € à 800 000 €",
    works: [
      "Récupération de chaleur sur air comprimé (huile & air chaud)",
      "Échangeurs sur fumées de four ou de chaudière",
      "Récupération sur groupes froids (désurchauffe + condensation)",
      "Boucles de récupération vers procédé, ECS ou chauffage bâtiment",
      "Pompes à chaleur haute température (jusqu'à 120°C) sur sources fatales",
      "Instrumentation & monitoring du gisement récupérable",
    ],
  },
  {
    slug: "froid-industriel",
    icon: Snowflake,
    label: "Froid industriel",
    tagline: "Refonte des installations frigorifiques pour -30 à -50 % de conso.",
    fiche: "IND-UT-102 · IND-UT-121",
    valorisation: "80 000 € à 2 M€",
    works: [
      "Remplacement des groupes HFC par CO₂ transcritique ou NH₃",
      "Optimisation aéraulique des chambres froides & tunnels",
      "Régulation flottante des pressions de condensation & évaporation",
      "Variation de vitesse sur compresseurs, condenseurs, ventilateurs",
      "Sous-refroidissement mécanique / free-cooling glacé",
      "Décongélation intelligente & pilotage GTC",
    ],
  },
  {
    slug: "air-comprime",
    icon: Wind,
    label: "Air comprimé",
    tagline: "L'énergie la plus chère du site — souvent gaspillée à 40 %.",
    fiche: "IND-UT-103 · IND-UT-116",
    valorisation: "20 000 € à 350 000 €",
    works: [
      "Traque et réparation de fuites (audit ultrasonique)",
      "Variation de vitesse sur compresseurs & régulation cascade",
      "Baisse de la pression de service (0,5 à 1 bar)",
      "Récupération de chaleur sur circuit huile",
      "Sécheurs à cycle frigo régulés en fonction du débit",
      "Réseau optimisé (bouclé, sur-dimensionné, décentralisé)",
    ],
  },
  {
    slug: "chaudieres-fours",
    icon: Factory,
    label: "Chaudières & fours",
    tagline: "Combustion contrôlée, isolation, biomasse, électrification.",
    fiche: "IND-UT-101 · IND-UT-118",
    valorisation: "40 000 € à 1,5 M€",
    works: [
      "Économiseurs sur fumées de chaudière & condenseurs",
      "Bruleurs modulants et régulation O₂",
      "Substitution fioul/gaz vers biomasse ou PAC HT",
      "Isolation de fours industriels (voûtes, portes, sole)",
      "Récupération de chaleur sur fumées de four vers procédé",
      "Électrification des procédés basse température",
    ],
  },
  {
    slug: "reseaux-vapeur",
    icon: Waves,
    label: "Réseaux vapeur",
    tagline: "Purgeurs, calorifugeage, condensats — 15-25 % de pertes typiques.",
    fiche: "IND-UT-105 · IND-UT-115",
    valorisation: "15 000 € à 250 000 €",
    works: [
      "Audit acoustique des purgeurs (souvent 20 % défectueux)",
      "Remplacement / mise à niveau des purgeurs vapeur",
      "Calorifugeage complet de la vapeur, condensats & vannes",
      "Récupération des condensats vers bâche alimentaire",
      "Recompression mécanique ou thermique de vapeur (CMV/CTV)",
      "Suppression des fuites vapeur & isolation des accessoires",
    ],
  },
  {
    slug: "pompes-circulateurs",
    icon: Droplets,
    label: "Pompes & circulateurs",
    tagline: "Passez d'un fonctionnement continu à un fonctionnement à la demande.",
    fiche: "IND-UT-108 · BAT-EQ-111",
    valorisation: "8 000 € à 180 000 €",
    works: [
      "Remplacement par pompes haute efficacité (IE4/IE5)",
      "Variation de vitesse sur pompes de process & de bouclage",
      "Optimisation hydraulique (tuyauterie, vannes, filtres)",
      "Pompes à roue périphérique pour faibles débits",
      "Circulateurs à cœur intelligent pour bouclages ECS",
      "Sous-comptage énergie et monitoring temps réel",
    ],
  },
  {
    slug: "moteurs-variateurs",
    icon: Cog,
    label: "Moteurs & variateurs",
    tagline: "IE4/IE5 + variation de vitesse = -30 % sur les usages moteurs.",
    fiche: "IND-UT-102 · IND-UT-134",
    valorisation: "10 000 € à 400 000 €",
    works: [
      "Substitution moteurs IE1/IE2 vers IE4 / IE5 premium",
      "Installation de variateurs de vitesse (ventilateurs, pompes, convoyeurs)",
      "Redimensionnement des moteurs sur-dimensionnés",
      "Régulation en cascade sur groupes de compresseurs",
      "Freinage régénératif sur applications répétitives",
      "Monitoring vibratoire & prédictif",
    ],
  },
  {
    slug: "gtb-gtc",
    icon: Cpu,
    label: "GTB / GTC",
    tagline: "Le cerveau du bâtiment — 15 à 40 % d'économies immédiates.",
    fiche: "BAT-TH-116 · BAT-TH-117",
    valorisation: "20 000 € à 350 000 €",
    works: [
      "Déploiement d'une GTB de classe A (NF EN ISO 52120-1)",
      "Régulation multi-zones du chauffage & de la ventilation",
      "Programmation horaire fine + inoccupation & vacances",
      "Optimisation loi d'eau, courbes de chauffe & consignes glissantes",
      "Sous-comptage énergie par usage (chauffage, ECS, éclairage)",
      "Reporting énergétique et alarmes de dérives",
    ],
  },
  {
    slug: "cta-ventilation",
    icon: Gauge,
    label: "CTA & ventilation",
    tagline: "Débit à la demande, récupération de chaleur, moteurs EC.",
    fiche: "BAT-TH-127 · BAT-TH-146",
    valorisation: "18 000 € à 280 000 €",
    works: [
      "Récupération de chaleur sur air vicié (échangeurs rotatifs / à plaques)",
      "Ventilation à débit d'air variable (CO₂, hygrométrie, présence)",
      "Moteurs EC sur ventilateurs de CTA & rejets",
      "Free-cooling nocturne & mécanique",
      "Filtration haute performance basse perte de charge",
      "Nettoyage et rééquilibrage aéraulique complet",
    ],
  },
  {
    slug: "pompes-a-chaleur",
    icon: Thermometer,
    label: "Pompes à chaleur",
    tagline: "COP 3 à 5 — la solution reine du remplacement des chaudières.",
    fiche: "BAR-TH-104 · BAT-TH-113 · BAR-TH-137",
    valorisation: "6 000 € à 500 000 €",
    works: [
      "PAC air/eau haute température en remplacement de chaudières fioul/gaz",
      "PAC eau/eau géothermale (sondes verticales ou nappe)",
      "PAC hybrides (chaudière + PAC) pour l'existant",
      "PAC collectives en copropriété (Coup de Pouce collectif)",
      "PAC industrielles haute température jusqu'à 120°C",
      "PAC piscine, ECS et thermodynamique",
    ],
  },
  {
    slug: "isolation-enveloppe",
    icon: Layers,
    label: "Isolation & enveloppe",
    tagline: "La meilleure énergie est celle qu'on ne consomme pas.",
    fiche: "BAR-EN-101 à 108 · BAT-EN-101 à 108",
    valorisation: "5 000 € à 600 000 €",
    works: [
      "ITE (isolation thermique par l'extérieur) — polystyrène, laine minérale, biosourcé",
      "ITI (par l'intérieur) — solutions déportées pour éviter les ponts thermiques",
      "Isolation des combles perdus & rampants",
      "Isolation des planchers bas & sous-sols",
      "Calorifugeage industriel des réseaux & équipements",
      "Menuiseries double/triple vitrage & étanchéité à l'air",
    ],
  },
  {
    slug: "eclairage-performant",
    icon: Lightbulb,
    label: "Éclairage performant",
    tagline: "LED + détection = -60 à -80 % sur le poste éclairage.",
    fiche: "BAT-EQ-127 · IND-BA-112",
    valorisation: "10 000 € à 220 000 €",
    works: [
      "Relamping LED complet (bureaux, ateliers, entrepôts, parkings)",
      "Détection de présence + gradation en fonction de la lumière naturelle",
      "Éclairage circadien pour bâtiments santé & hôtellerie",
      "GTB éclairage centralisée (scénarios & agendas)",
      "Réflecteurs et lentilles adaptés au poste de travail",
      "Éclairage de sécurité LED à source unique",
    ],
  },
  {
    slug: "energies-renouvelables",
    icon: Sun,
    label: "Énergies renouvelables",
    tagline: "Solaire thermique, PV autoconsommation, biomasse & géothermie.",
    fiche: "BAR-EN-103 · IND-UT-115 · Fonds Chaleur",
    valorisation: "30 000 € à 1,2 M€",
    works: [
      "Solaire thermique pour ECS & procédés industriels basse T",
      "Photovoltaïque en autoconsommation (toitures & ombrières)",
      "Chaufferies biomasse (bois-énergie, plaquettes forestières)",
      "Réseaux de chaleur bas carbone",
      "Géothermie de surface & profonde",
      "Cogénération biomasse ou biogaz",
    ],
  },
  {
    slug: "renovation-globale",
    icon: HomeIcon,
    label: "Rénovation globale",
    tagline: "Programmes coordonnés isolation + chauffage + ventilation + ENR.",
    fiche: "BAR-TH-164 · BAT-TH-146 · MaPrimeRénov' Copro",
    valorisation: "60 000 € à 1,5 M€ / copropriété",
    works: [
      "Audit énergétique global & scénarios BBC Rénovation",
      "Bouquet ITE + PAC + VMC double flux + solaire",
      "Programmes Coup de Pouce & MaPrimeRénov' Copropriétés",
      "Assistance à maîtrise d'ouvrage AMO",
      "Coordination des lots travaux (isolation, CVC, électrique)",
      "Suivi post-livraison & mesure IPMVP sur 3 ans",
    ],
  },
];
